var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 15,
    viewBox: "0 0 19 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "credit-card-Filled_1_",
    d: "M460,2629.5H450a4.507,4.507,0,0,0-4.5,4.5h19A4.507,4.507,0,0,0,460,2629.5Zm-14.5,6.5v4a4.507,4.507,0,0,0,4.5,4.5h10a4.507,4.507,0,0,0,4.5-4.5v-4Zm7.5,5h-3a1,1,0,0,1,0-2h3a1,1,0,0,1,0,2Z",
    transform: "translate(-445.5 -2629.5)",
    fill: "#727272"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/credit-card.6faecc9384177ff5cb26819e25221edb.svg";
export { ForwardRef as ReactComponent };